// Generated by CoffeeScript 2.7.0
var PhaseFieldsEditorModal, field_list, modal_comp;

import FieldList from 'trunks/vue/admin/components/fields/list/fieldable.js';

import Modal from 'trunks/vue/admin/components/modals/modal.js';

modal_comp = Modal;

field_list = FieldList;

export default PhaseFieldsEditorModal = Vue.extend({
  components: {
    modal: modal_comp,
    'field-list': field_list
  },
  props: {
    phase: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasContent: function() {
      var ref;
      return Boolean((ref = this.phase.fields) != null ? ref.length : void 0);
    }
  },
  template: `<modal title='设置处理者回传字段'
       extendClass='phase-fields-modal'
       :backdrop='true'
       @afterClosed='saveChanges'
       ref='modal'>
  <template>
    <field-list ref='fieldList'
                :fields='phase.fields'
                v-show='hasContent'
                :fieldable='phase'
                :disables='["marked", "value_cache", "visibility", "fillSettings"]' />
    <div class="formable-actions">
      <div class="slp-tooltip right" data-title="添加表项">
        <div class="action-item clickable" @click='addField'>
          <i class="slp-plus-circle"></i>
        </div>
      </div>
      <div class="slp-tooltip right" data-title="添加章节">
        <div class="action-item clickable" @click='addSectionBreak'>
          <i class="slp-text-square"></i>
        </div>
      </div>
    </div>
    <div class="blankslate" v-if='!hasContent'>
      <i class="slp-warning-circle-o"></i>
      <p>没有“回传字段”</p>
    </div>
  </template>
  <div class="modal-footer" slot='footer'>
    <div class="justify-between">
      <span></span>
      <div class='force-no-wrap'>
        <button @click='dismissModal'>关闭</button>
      </div>
    </div>
  </div>
</modal>`,
  methods: {
    dismissModal: function() {
      return this.$refs.modal.close();
    },
    saveChanges: function() {
      return this.$emit('save', this.phase.fields);
    },
    addField: function() {
      return this.$refs.fieldList.addNewField();
    },
    addSectionBreak: function() {
      return this.$refs.fieldList.addNewField('Field::SectionBreak');
    }
  }
});
